import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { CertificateBody } from "../components/CertificateShowcase";

export default function OCertifikate() {
  const navigate = useNavigate();
  useEffect(() => { window.scrollTo(0, 0); }, []);
  return (
    <div data-testid="o-certifikate-page" className="min-h-screen bg-[#070707] pt-28 pb-24">
      <div className="mx-auto max-w-3xl px-6 sm:px-10">
        <div className="border border-[#D4AF37]/20 bg-gradient-to-b from-[#0d0d0c] to-[#070707] overflow-hidden">
          <div className="h-1 w-full bg-gradient-to-r from-transparent via-[#D4AF37] to-transparent" />
          <div className="px-6 sm:px-12 py-10 sm:py-12">
            <CertificateBody onCta={() => navigate("/ziadost")} />
          </div>
        </div>
      </div>
    </div>
  );
}
